import { z } from 'zod'

const DataDropsApiKeysSchema = z.object({
  id: z.string(),
  name: z.string(),
  key: z.string(),
  createdAt: z.date(),
  expiresAt: z.date(),
})

export const GetDataDropsApiKeysResponseBody = z.object({
  keys: z.array(DataDropsApiKeysSchema),
  maxKeysPerUser: z.number().safe(),
})

export const CreateDataDropsApiKeyRequestBody = z.object({
  name: z.string(),
})

export const CreateDataDropsApiKeyResponseBody = DataDropsApiKeysSchema.pick({
  key: true,
})
